import React from 'react';

interface AboutUsProps {}

const AboutUs: React.FC<AboutUsProps> = () => {
  return (
    <section id="sobre" className="about-us">
      <div className="container">
      <section className="company-info">
          <h3>Nosso Propósito</h3>
          <p>&emsp;Na T&B Softwares, nossa paixão é desenvolver soluções de software inovadoras e eficientes que impulsionem o sucesso de nossos clientes. Buscamos simplificar processos, otimizar operações e fornecer ferramentas poderosas para enfrentar os desafios do mundo digital.</p>

          <h3>Nossos Valores</h3>
          <ul>
            <li><strong>Inovação:</strong> Buscamos constantemente novas tecnologias e abordagens para criar soluções de ponta.</li>
            <li><strong>Qualidade:</strong> Nosso compromisso é entregar software robusto, confiável e com alto padrão de qualidade.</li>
            <li><strong>Colaboração:</strong> Acreditamos no trabalho em equipe e na parceria com nossos clientes para alcançar os melhores resultados.</li>
            <li><strong>Foco no Cliente:</strong> As necessidades e o sucesso de nossos clientes são a nossa prioridade.</li>
          </ul>
          <h3>Quem Ajudamos</h3>
          <p>Nossas soluções de software são destinadas a:</p>
          <ul>
            <li><strong>Pequenas e Médias Empresas (PMEs):</strong> Que buscam otimizar seus processos e crescer de forma sustentável.</li>
            <li><strong>Empreendedores:</strong> Que necessitam de ferramentas digitais para lançar e gerenciar seus negócios.</li>
            <li><strong>Profissionais:</strong> Que desejam aumentar sua produtividade e eficiência através de software especializado.</li>
            <li><strong>Organizações:</strong> De diversos setores que buscam soluções personalizadas para seus desafios específicos.</li>
          </ul>
        </section>
      </div>
    </section>
  );
};

export default AboutUs;